import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setTaskFiltersRoutine } from 'features/taskManagement/ducks/actions'

export const TASK_SEARCH_DEBOUNCE_MS = 300

export const useTaskSearchFilter = appliedSearch => {
  const dispatch = useDispatch()
  const [searchValue, setSearchValue] = useState(() => appliedSearch || '')

  useEffect(() => {
    const next = searchValue.trim()
    if (next === (appliedSearch || '')) return undefined
    const t = setTimeout(() => dispatch(setTaskFiltersRoutine({ search: next })), TASK_SEARCH_DEBOUNCE_MS)
    return () => clearTimeout(t)
  }, [searchValue, appliedSearch, dispatch])

  return [searchValue, setSearchValue]
}
